import { vars } from "@imwebme/clay-token";
import type { CSSProperties } from "react";
import type { TypographyProps } from "../Typography/Typography.types";
import type { HeadingProps } from "./Heading.types";

export const headingRecipe = ({
  size,
}: Pick<HeadingProps, "size">): {
  textVariant: TypographyProps<"p">["variant"];
  root: CSSProperties;
} => {
  switch (size) {
    case "small":
      return {
        root: {
          gap: vars.spacing[3],
        },
        textVariant: "heading-medium-bold",
      };

    case "medium":
      return {
        root: {
          gap: vars.spacing[1],
        },
        textVariant: "heading-large-bold",
      };

    case "large":
      return {
        root: {
          gap: vars.spacing[2],
        },
        textVariant: "heading-xlarge-bold",
      };

    default:
      return {
        root: {
          gap: vars.spacing[3],
        },
        textVariant: "heading-2xlarge-bold",
      };
  }
};
